<button type="button" class="close cross" aria-label="Close" (click)="dismiss(undefined)">
    <span aria-hidden="true">&times;</span>
</button>
<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
  {{ message }}
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger white" (click)="dismiss('btn')">{{ btnCancelText }}</button>
  <button type="button" class="btn btn-primary green" (click)="accept()">{{ btnOkText }}</button>
</div>

<div class="d-flex justify-content-center cover-spin" *ngIf="saving">
  <div class="spinner-border" role="status">
     <span class="sr-only">Saving...</span>
  </div>
</div>
  